export const msToSeconds = (n: number) => n / 1000
